import React from 'react';
import glamorous from 'glamorous';

import { font } from '../../styles';
import { propTypes, defaultProps } from './types';

export const rules = {
  fontWeight: 200,
  fontSize: font.getFontSize(0.8409),
  lineHeight: font.getLineHeight(1.5),
};

const style = props => ({
  ...rules,
  textAlign: props.align,
  ...props.glamStyle,
});

const baseStyle = style({});
const Span = glamorous.span(baseStyle, style);

class Caption extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;
  static rules = rules;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <Span {...rest} glamStyle={style}>
        {children}
      </Span>
    );
  }
}

export default Caption;



// WEBPACK FOOTER //
// ./src/components/typography/Caption.js